// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconTimer: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path
                fill="currentColor"
                d="M7,0 C6.61354211,0 6.30000045,0.313541667 6.30000045,0.7 L6.30000045,3.03333333 C6.30000045,3.42124964 6.61500053,3.73333333 7,3.73333333 C7.3850008,3.73333333 7.70000045,3.41979167 7.70000045,3.03333333 L7.70000045,1.44375 C10.4591673,1.78908323 12.6000004,4.15041631 12.6000004,7 C12.6000004,10.0887498 10.0878753,12.6 7,12.6 C3.91212559,12.6 1.40000045,10.0878749 1.40000045,7 C1.40000045,5.79512507 1.77654222,4.64741656 2.48820871,3.68083369 C2.71789621,3.36904195 2.65136687,2.93154195 2.3405667,2.70200043 C2.02883326,2.47333298 1.58958333,2.54041684 1.36179174,2.85249964 C0.47133344,4.06000036 0,5.49499982 0,7 C0,10.8587496 3.14124991,14 6.97375018,14 C10.80625,14 14,10.8587496 14,7 C14,3.14125036 10.8587496,0 7,0 L7,0 Z M6.50416667,7.46958351 C6.6409001,7.6063165 6.81945826,7.67465452 6.99912504,7.67465452 C7.17879181,7.67465452 7.35729167,7.60628802 7.4940834,7.46958351 C7.7675209,7.19614601 7.7675209,6.75325025 7.4940834,6.47966677 L5.18699989,4.14633344 C4.91356239,3.87289594 4.47066663,3.87289594 4.19708316,4.14633344 C3.92349968,4.41977094 3.92364566,4.8626667 4.19708316,5.13625018 L6.50416667,7.46958351 Z"
            />
        </svg>
    );
};

export default React.memo(IconTimer);
